<style scoped>
pre {
 white-space: pre-wrap;       /* css-3 */
 white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
 white-space: -pre-wrap;      /* Opera 4-6 */
 white-space: -o-pre-wrap;    /* Opera 7 */
 word-wrap: break-word;       /* Internet Explorer 5.5+ */
}
</style>
<template>
<v-card class='grey lighten-4 pb-5' height='100%' >

  <a :id="`space-${serviceId}`" ></a>
  <request-status :request='requests.space' @ok='edittitle=false' />
  <v-dialog v-model='backgroundDialog' fullscreen >
    <v-card flat>
      <v-card-title class='grey lighten-4 py-0' >
        Choose a background picture
        <v-spacer/>
        <v-btn @click='backgroundDialog=false' icon ><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <image-search
        v-model='settings.background_picture'
        title='Search for an image'
        @input='saveBackground' >
      </image-search>
    </v-card>
  </v-dialog>
  <v-img height='250'
    v-if='settings && settings.background_picture'
    :src='settings.background_picture' >
    <v-card-title
      class='title pl-4 white--text'
      style="background-color: rgba(0, 0, 0, 0.6);" >
      <v-text-field dark
        v-if='edittitle'
        v-model='service.title'
        :loading='requests.space.loading'
        @blur='saveTitle'
        @keypress.enter='saveTitle'
        @click:append='saveTitle'
        append-icon='save' />
      <span v-else @click.stop='edittitle=true' >{{ service.title }}

        <v-btn dark icon small >
          <v-icon small >edit</v-icon>
        </v-btn>
      </span>
      <v-spacer />
      <v-btn v-if='!expand'
        @click.stop='expand=true;$vuetify.goTo(`#space-${service.id}-settings`)'
        color='primary' >Edit</v-btn>
      <v-btn v-else icon @click.stop='expand=false'  color='primary' >
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title >
    <v-btn absolute bottom right small dark class='mb-5' @click="backgroundDialog=true" >
      Click to change background picture
    </v-btn>
  </v-img>
  <v-divider />

  <v-dialog v-model='logoDialog' width='400' >
    <v-card flat >
      <v-card-title class='grey lighten-4 py-0' >
        Update your Logo
        <v-spacer/>
        <v-btn @click='logoDialog=false' icon ><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <uploader
        @uploadsuccess='reload();logoDialog=false'
        :upload-path='logoUploadPath'
        filename='logo_picture' >
        <template slot='gallery' slot-scope="props">
          <v-subheader>Examples of how this may look in various places</v-subheader>
          <v-layout v-for='(img, index) in props.images' :key="index" >
            <v-flex>
              <v-subheader>Avatar view</v-subheader>
              <v-avatar ><img :src="img" /></v-avatar></v-flex>
            <v-flex>
              <v-subheader>Normal view</v-subheader>
              <img :src="img" /></v-flex>
          </v-layout>
        </template>
      </uploader>
    </v-card>
  </v-dialog>

  <v-card-text v-if='settings' style='text-align:right;' class='mb-3' >
    <div><strong>Practice name</strong> {{settings.practice_name}}</div>
    <div><strong>Practice number</strong> {{settings.practice_number}}</div>
  </v-card-text>

  <v-card absolute
    class='ml-4 elevation-10 align-end'
    width='200' height='180'
    style='margin-top:-220px'
    @click='logoDialog=true' >

      <template v-if='settings.logo_picture' >
        <v-img :src='settings.logo_picture' height='150' max-width='200' contain />
        <v-footer tile dark
          class='caption justify-center ma-0'
          style="background-color: rgba(0, 0, 0, 0.6);" >
          Click to edit logo
        </v-footer>
      </template>
      <v-card-text v-else class='pt-5 subheading' >
        <center>
          <v-icon>image</v-icon><br/>
          Click to upload a logo
        </center>
      </v-card-text>
  </v-card>

  <v-dialog v-model='invoicesettingsDialog' >
    <v-card >
      <request-status :request='requests.service.settings' @ok='reload();invoicesettingsDialog=false' />
      <v-card-title class='grey lighten-4 py-0' >
        Invoice settings
        <v-spacer/>
        <v-btn @click='invoicesettingsDialog=false' icon ><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <invoice-settings
        v-model='settings'
        :space-id='spaceId'
        :loading='requests.service.settings.loading'
        @input='saveSettings'
        @close='invoicesettingsDialog=false' />
    </v-card>
  </v-dialog>

  <a :id="`space-${service.id}-settings`" ></a>
  <template v-if='settings' >

    <v-subheader class="overline mt-5 ">
      <v-icon small color='accent' class='mr-2' >post_add</v-icon>
      Invoice details
      <v-spacer/>
    </v-subheader>

    <v-card
      :id='`service-${service.id}-invoice-settings`'
      class='mx-3'
      @click='invoicesettingsDialog=true' >
      <request-status :request='requests.service.settings' />
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 sm6 md3
            v-for='field in invoicesettingfields'
            :key='field' class='mt-2' >
            <strong v-text='field.replace("_", " ")' />
            <pre class='caption' v-text='settings[field]' />
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-card-actions >
        <v-spacer/>
        <v-btn outline small >Edit</v-btn>
      </v-card-actions>
    </v-card>

  </template>

    <!-- PaymentSettings -->
  <v-subheader class='overline' >
    <v-icon small color='accent' class='mr-2' >paid</v-icon>
    Payments
  </v-subheader>

  <v-card class='mx-3' >
    <v-card-actions>
      <img src="https://dropbox-appointmentguru.s3.eu-central-1.amazonaws.com/yoco.jpeg"
        height='50' />


      <v-list-tile :href='yocoIntegrationLink' >
        <v-list-tile-content>
          <v-list-tile-title>Accept payments with Yoco</v-list-tile-title>
          <v-list-tile-sub-title v-if='yocoIntegrationLink' >
            {{ yocoIntegrationLink }}</a>
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-spacer />
      <template v-if='yocoIntegration && yocoIntegration.id' >
        <v-chip color='success' dark class='mr-3' >
          <v-icon left >check_circle</v-icon>
          Configured
        </v-chip>
        <v-btn @click='configureYocoDialog=true' >Edit</v-btn>
      </template >
      <template v-else >
        <v-btn href="https://referral.yoco.com/32Tzfb" target="_blank" >
          Open a free Yoco account
          <v-icon >open_in_new</v-icon>
        </v-btn>
        <v-btn @click='configureYocoDialog=true' color='primary' >Configure</v-btn>
      </template>

    </v-card-actions>
    <v-dialog v-model='configureYocoDialog' >
      <v-card>
        <v-card-title class='grey lighten-4 py-0' >
          Configure Yoco
          <v-spacer/>
          <v-btn @click='configureYocoDialog=false' icon ><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <yoco v-if='configureYocoDialog' :space-id='serviceId' @ok="$emit('reload')" />
      </v-card>
    </v-dialog>
    <v-footer v-if='settings && (yocoIntegration && yocoIntegration.id)' >
      <v-chip outline
        v-if='settings.payment_invoices_visible'
        class="v-chip--x-small" >
        <v-icon left small >check</v-icon> Show on invoices
      </v-chip>
      <v-chip outline
        v-if='settings.payment_appointments_visible'
        class="v-chip--x-small" >
        <v-icon left small >check</v-icon> Show on appointment page
      </v-chip>
      <v-chip outline
        v-if='settings.payment_appointments_prepayments'
        class="v-chip--x-small" >
        <v-icon left small >check</v-icon> Allow pre-payments
      </v-chip>
      <v-chip outline
        v-if='settings.payment_appointments_only_if_invoiceable'
        class="v-chip--x-small" >
        <v-icon left small >check</v-icon> Only show if appointment marked as invoiceable
      </v-chip>
    </v-footer>
  </v-card>

  <v-card-actions class='mt-2' >
    <template v-if='!expand' >
      <v-btn @click='expand=true' flat >More details
        <v-icon>expand_more</v-icon>
      </v-btn>
      <v-chip v-if='service && service.addresses' small label outline >{{service.addresses.length}} locations</v-chip>
      <v-chip v-if='service && service.products' small label outline >{{service.products.length}} appointment types</v-chip>
    </template>
    <template v-else >
      <v-spacer/>
      <v-btn @click='expand=false' flat >Hide details
        <v-icon small class='ml-2' >close</v-icon>
      </v-btn>
    </template>
  </v-card-actions>

  <template v-if='expand' >

    <v-card-text >
      <v-subheader class='overline pl-0' >
        <v-icon small color='accent' class='mr-2' >location_on</v-icon>
        Locations
        <v-spacer />
        <v-btn small outline class='primary mr-0' @click="showCreateLocation=true" >
          <v-icon small >add</v-icon>
          New
        </v-btn>
      </v-subheader>

      <p v-if='service.addresses && service.addresses.length === 0' class='error--text' >
        There are no locations for this space.
        <v-btn @click='showCreateLocation=true' small flat >Create a location now</v-btn> or
        <v-btn @click='showDeleteConfirmation=true' small flat >archive the space</v-btn> if you are no longer using it
      </p>
      <v-dialog v-model='showCreateLocation' >
        <location-create with-close
          :space-id='service.id'
          :touch='showCreateLocation'
          @save='saveAddress'
          @created='reload'
          @close='showCreateLocation=false' />
      </v-dialog>
      <v-progress-linear v-if='globalDataLoading' indeterminate class='ma-0' height='2' />
      <v-expansion-panel class='elevation-1' >



        <v-expansion-panel-content
          v-for="(address, index) in service.addresses"
          @click.native='activeIndex = index'
          :key="`loc-s-${service.id}-${index}`">

          <v-list dense class='pa-0' slot="header">
            <v-list-tile v-if='address.name' >
              <v-list-tile-avatar >
                <v-icon>location_on</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title >
                  <v-chip outline label class='v-chip--x-small' >{{address.id}}</v-chip>
                  {{address.name}}
                  <v-chip color='primary' class='v-chip--x-small' dark tile v-if='service.owner_id === me.id' >Owner</v-chip>
                  <v-chip color='success' class='v-chip--x-small' dark tile v-if='service.private' >Private</v-chip>
                </v-list-tile-title>
                <v-list-tile-sub-title v-text='address.address'>
                </v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn flat small
                      v-bind="attrs" v-on="on"
                      @click.stop='showLocationDiaog(service, address, "assign")' >
                      Assign</v-btn>
                  </template>
                  <span>Assign appointment types to this location</span>
                </v-tooltip>
              </v-list-tile-action>

              <v-list-tile-action >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn flat small
                      v-bind="attrs" v-on="on"
                      @click.stop='showLocationDiaog(service, address, "move")' >Move
                    </v-btn>
                  </template>
                  <span>Move this location to a different space</span>
                </v-tooltip>
              </v-list-tile-action>

              <v-list-tile-action >
                <v-btn icon small >
                  <v-icon small>edit</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
            <v-list-tile v-else @click='locationComponent="LocationEdit"' >
              <v-list-tile-avatar >
                <v-icon>warning</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>Please provide a name</v-list-tile-title>
                <v-list-tile-sub-title >Click to edit</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action >
                <v-btn flat text >Edit</v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>

          <v-card >
            <v-card-text>
              <v-layout row wrap >

                <!-- edit location -->
                <v-flex md6 class="pa-2" >
                  <v-card height='100%'>
                    <component
                      :is='locationComponent'
                      :location='address'
                      @close='locationComponent="LocationView"'
                      @save='saveAddress'
                      @saved='reload'
                      @edit='locationComponent="LocationEdit"' ></component>
                  </v-card>
                  <!-- <location-view :location='service' ></location-view> -->
                </v-flex>

                <!-- edit operating hours -->
                <v-flex md6 class="pa-2" >
                  <v-card height='100%'>
                    <v-card-title>
                      <v-subheader class='overline' >Operating hours</v-subheader>
                      <v-spacer></v-spacer>
                    </v-card-title>

                    <v-expansion-panel :value='0' class='elevation-0' >
                      <template v-for="(hours, index) in address.operation_hours_data" >
                        <v-expansion-panel-content v-if='getPractitionerById(hours.practitioner_id)' :key="hours.id" >
                          <template v-slot:header>
                            <div
                              v-if='getPractitionerById(hours.practitioner_id)'
                              class='subheading' >{{ getPractitionerById(hours.practitioner_id).full_name }}</div>
                          </template>
                          <v-card >
                            <v-divider/>
                            <v-card-text>
                              <operating-hours-view lazy
                                v-model="address.operation_hours_data[index]"
                                :hours="hours" />
                              <!-- <component
                                :is='hoursComponent'
                                v-model="address.operation_hours_data[index]"
                                :hours='hours' >
                              </component> -->
                            </v-card-text>
                            <!-- <v-card-actions v-if='hoursComponent==="OperatingHours"' >
                              <v-btn @click='hoursComponent="OperatingHoursView"' flat small >Cancel</v-btn>
                              <v-spacer></v-spacer>
                              <vuex-btn :req-id='requests.service.hours' @save='saveHours(service.hours)' text='Save' ></vuex-btn>
                            </v-card-actions> -->
                          </v-card>
                        </v-expansion-panel-content>
                      </template>
                    </v-expansion-panel>
                    <!-- <v-card-text class='ml-3' >
                        <component
                          :is='hoursComponent'
                          v-model="address.operation_hours"
                          :hours='address.operation_hours' >
                        </component>
                    </v-card-text>
                     -->
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card-text>

            <v-card-actions class='grey lighten-2' >
              <v-spacer/>
              <v-btn
                @click='showLocationDiaog(service, address, "delete")'
                color='error' >Delete</v-btn>
              <v-spacer/>
            </v-card-actions>

          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-card-text>

    <v-card-text>
      <v-subheader class='overline pl-0' >
        <v-icon small color='accent' class='mr-2' >star</v-icon>
        Appointment Types
      </v-subheader>
      <product-edit
        v-model='service'
        @deleted='reload'
        @saved='reload'
        @added='reload' />
    </v-card-text>

    <v-card-text>
      <v-subheader class='overline pl-0' >
        <v-icon small color='warning' class='mr-2' >warning</v-icon>
        Danger Zone</v-subheader>
      <v-btn @click='showDeleteConfirmation=true' color='error' >
        <v-icon class='mr-2' >archive</v-icon> Archive
      </v-btn>
      <v-dialog v-model='showDeleteConfirmation' >
        <v-card>
          <request-status
            :request='servicesArchiveRequest'
            @ok='spaceArchived' />

          <v-card-title class='subheading'>
            Archive {{service.title}}?
            <v-spacer></v-spacer>
            <v-btn @click='showDeleteConfirmation=false' icon><v-icon>close</v-icon></v-btn>
          </v-card-title>
          <v-card-text>
            <strong>What happens when I click archive</strong><br/>
            <p>If this space has no appointments, it will be permanently deleted.</p>
            <p>
            If the space has appiontments, it will be archived.<br/>
            An archived space is hidden from sight, but can be recovered should need be.<br/>
            All existing appointments in this space will remain in this space.<br/>
            </p>

          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn flat @click='showDeleteConfirmation=false'>Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn @click="archiveSpace" color="error" :loading='servicesArchiveRequest.loading' >
              Archive {{service.title}}
            </v-btn>

            <!-- <vuex-btn v-if='confirmDelete === address.name'
              @save='deleteRequested'
              :req-id='reqId' text='Archive'
              color='error' >
            </vuex-btn> -->

          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-text>

  </template>
  <v-footer absolute bottom class='py-0 grey lighten-2 caption' >
    <v-chip class='v-chip--x-small my-0' label outline > #{{service.id}}</v-chip>
  </v-footer>

  <v-dialog
    v-model='showDeleteLocation'
    v-if='selectedAddress' >
    <v-card>
      <request-status
        @ok='reload();showDeleteLocation=false'
        :request='requests.address'
        message204='Address has been deleted. Reloading' />
      <v-card-title class='subtitle-1 overline' >
        Are you sure you want to delete {{selectedAddress.name}}
      </v-card-title>
      <v-card-text>
      </v-card-text>
      <v-card-actions >
        <v-btn flat @click='showDeleteLocation=false' >Cancel</v-btn>
        <v-spacer/>
        <v-btn
          @click='deleteAddress(selectedAddress.id)'
          :loading='requests.address.loading'
          color='error' >Delete</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog
    v-model='showAssignLocation'
    v-if='selectedSpace' >
    <location-assign with-close
      :space='selectedSpace'
      :location='selectedAddress'
      @saved='reload'
      @close='showAssignLocation=false' />
  </v-dialog>

  <v-dialog
    v-model='showMoveLocation'
    v-if='selectedSpace' >
    <move-location with-close
      @close='showMoveLocation=false'
      @setproducts='reload'
      :from-space='selectedSpace'
      v-model='selectedAddress' />
  </v-dialog>

</v-card>
</template>
<script>
import LocationView from './LocationView'
import LocationEdit from './LocationEdit'
import MoveLocation from './MoveLocation.vue'
import LocationCreate from './LocationCreate.vue'
import LocationAssign from './LocationAssign.vue'

// import CrudTable from '@/components/CrudTable'
import ProductEdit from './ProductEdit.vue'
import InvoiceSettings from '@/components/invoice/manage/InvoiceSettings.vue'
import Uploader from '@/components/pages/settings/media/Uploader.vue'
import ImageSearch from '@/components/ui/ImageSearch'
import Yoco from '@/components/pages/Integrations/Yoco.vue'

import {mapGetters} from 'vuex'
import OperatingHoursView from './OperatingHoursView.vue'
import RequestStatus from '../../../ui/RequestStatus.vue'

export default {
  name: 'SpaceSettings',
  components: {
    LocationView,
    LocationEdit,
    MoveLocation,
    LocationCreate,
    LocationAssign,
    ProductEdit,
    InvoiceSettings,
    Yoco,
    OperatingHoursView,
    ImageSearch,
    Uploader,
    RequestStatus
  },
  props: {
    value: { type: Object, required: true },
    initiallyExpanded: { type: Boolean, default: false }
  },
  data () {
    return {
      expand: false,
      edittitle: false,
      logoDialog: false,
      backgroundDialog: false,
      invoicesettingsDialog: false,
      configureYocoDialog: false,
      showDeleteLocation: false,
      showDeleteConfirmation: false,
      showCreateLocation: false,
      showMoveLocation: false,
      showAssignLocation: false,
      activeIndex: 0,
      selectedSpace: null,
      selectedAddress: null,
      locationComponent: 'LocationView',
      hoursComponent: 'OperatingHoursView',
      requests: {
        practitioner: 'practitioner-get-request',
        space: { resource: 'ag.spaces.practitioner' },
        address: { resource: 'ag.addresses' },
        service: {
          list: 'list-service-request',
          new: 'new-service-request',
          update: 'update-service-request',
          archive: 'archive-service-request',
          // hours: 'hrs-update-request',
          products: 'produts-update-save-request',
          settings: { resource: 'ag.spaces.settings' }
        }
      },
      invoicesettingfields: [
        'banking_details', 'billing_address', 'invoice_notes', 'receipt_notes'
      ],
      selectedPractitionerId: null
    }
  },
  mounted () {
    if (this.initiallyExpanded) { this.expand = true }
  },
  methods: {
    saveBackground () {
      let data = {background_picture: this.settings.background_picture}
      this.saveSettings(data)
      this.backgroundDialog = false
    },
    saveTitle () {
      let data = {title: this.service.title}
      this.saveSpace(data)
    },
    archiveSpace () {
      this.$appointmentguru
        .resource('practitioner.services')
        .id(this.requests.service.archive).delete(this.serviceId)
    },
    spaceArchived () {
      this.$vuetify.goTo(1)
      this.$emit('reload')
    },
    saveAddress (data) {
      let fields = ['name', 'address', 'latitude', 'longitude', 'place_data']
      let payload = {}
      fields.forEach((field) => {
        payload[field] = data[field]
      })

      this.$appointmentguru
        .resource('practitioner.services.address')
        .id(this.requests.service.update)
        .save(data.id, payload)
    },
    deleteAddress (addressId) {
      this.requests.address.resourceId = addressId
      this.$request('delete', this.requests.address)
    },
    saveSpace (data) {
      this.requests.space.resourceId = this.serviceId
      this.requests.space.data = data
      this.$request('save', this.requests.space)
    },
    saveSettings (data) {
      this.requests.service.settings.resourceId = this.settingsId
      this.requests.service.settings.kwargs = {spaceId: this.serviceId}
      this.requests.service.settings.data = data
      this.$request('save', this.requests.service.settings)
    },
    reload () {
      this.$emit('reload')
      // this.$appointmentguru.resource('practitioner.services').id(this.requests.service.list).list()
    },
    showLocationDiaog (space, address, action) {
      this.selectedSpace = space
      this.selectedAddress = address
      if (action === 'move') { this.showMoveLocation = true }
      if (action === 'assign') { this.showAssignLocation = true }
      if (action === 'delete') { this.showDeleteLocation = true }
    }
  },
  watch: {
    members: {
      immediate: true,
      handler () {
        if (this.members && this.members.length > 0) {
          this.selectedPractitionerId = this.members[0].id
        } else {
          this.selectedPractitionerId = this.meId
        }
      }
    },
    showMoveLocation () {
      if (this.showMoveLocation === false) {
        this.$emit('reload')
      }
    }
  },
  computed: {
    ...mapGetters(['getPractitionerById', 'getIntegration']),
    service () { return this.value },
    serviceId () { return this.getObjectPath(this.service, 'id', null) },
    spaceId () { return this.serviceId }, // alias
    members () { return this.getObjectPath(this.service, 'practitioners', null) },
    integrations () { return this.getObjectPath(this.service, 'integrations', []) },
    settings () { return this.getObjectPath(this.service, 'settings', {}) },
    settingsId () { return this.getObjectPath(this.settings, 'id', null) },
    yocoIntegration () {
      return this.integrations.find((i) => {
        return i.title === 'Yoco'
      })
    },
    yocoIntegrationLink () {
      return this.getObjectPath(this.yocoIntegration, 'settings.link')
    },
    logoUploadPath () {
      return `/api/v3/spaces/${this.service.id}/settings/${this.settings.id}/`
    },
    practitionerRequest () {
      return this.$store.getters.getRequestById(this.requests.practitioner, true)
    },
    servicesSaveRequest () {
      return this.$store.getters.getRequestById(this.requests.service.update, true)
    },
    servicesArchiveRequest () {
      return this.$store.getters.getRequestById(this.requests.service.archive, true)
    },
    servicesSaveProductRequest () {
      return this.$store.getters.getRequestById(this.requests.service.products, true)
    },
    servicesSaveRequestStatus () {
      return this.servicesSaveRequest.status
    },
    servicesArchiveRequestStatus () {
      return this.servicesArchiveRequest.status
    },
    servicesSaveHrsRequestStatus () {
      return this.servicesSaveHrsRequest.status
    },
    servicesSaveProductRequestStatus () {
      return this.servicesSaveProductRequest.status
    },
    practitioner () {
      return this.$store.getters.me
      // return this.getObjectPath(this.practitionerRequest, 'result.data', {})
    },
    numServices () {
      if (this.service) {
        return this.services.length
      }
      return 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// SpaceSettings.vue?b8cd6288